<template>
<!-- 课程预约弹窗 -->
<div class="enterModal">
    <el-dialog title="领取免费试听课程" :visible.sync="EnterModalVisible" v-if="user" :before-close="handleClose">
        <p style="margin-bottom:10px;">您预约的课程为：</p>
        <h3 style="margin-bottom:10px;color:#1F2D3D;font-size:20px;">莫卡乐概念美术免费试听公开课</h3>
        <p style="margin-bottom:20px;font-size:14px;">该操作仅仅作为<span style="font-weight:600;color:#1F2D3D">课程预约</span>，<span style="color:#FF4949">不会扣除您的费用。</span>您登记相关信息后，工作人员将会在12小时内联系您确认预约课程，<span style="font-weight:600;color:#1F2D3D">请您保持电话畅通。</span></p>
        <el-form :model="form" label-position="top" :rules="rules" ref="form">
            <el-form-item label="请填写您的称呼" v-if="!user.RealName" prop="EnterParentName">
                <el-input v-model="form.EnterParentName"></el-input>
            </el-form-item>
            <el-form-item label="请选择报名课程的学员" prop="EnterBabyID">
                <a href="javascript:;" class="select-students-box" :class="form.EnterBabyID==item.BabyID?'select-students-active':''" v-for="(item,index) in user.BabyFromParent" :key="index" @click="selectStudent(item)">
                    <el-image fit="cover" :src="ip + 'media/'+ item.UserImg"></el-image>
                    <div class="plus-text-box">
                        <p>{{item.RealName}}</p>
                        <p style="color:#5E6D82">学号：{{item.BabyID}}</p>
                    </div>
                    <img src="static/img/select_icon.svg" v-if="form.EnterBabyID==item.BabyID">
                </a>
                <a href="javascript:;" class="plus-students-box" @click="addStudent">
                    <div class="plus-img-box">
                        <img src="static/img/el-icon-plus.svg" alt="">
                    </div>
                    <div class="plus-text-box">
                        <p v-text="user.BabyFromParent.length==0?'您还没有创建学员':'其他报名的学员？'"></p>
                        <p style="color:#57BC4C">点击创建</p>
                    </div>
                </a>
            </el-form-item>
            <el-form-item label="选择到店确认时间">
                <el-date-picker v-model="form.EnterDateTime" type="datetime" placeholder="选择日期时间" default-time="14:00:00">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="submitForm('form')">立即预约</el-button>
        </div>
    </el-dialog>
</div>
<!-- 课程预约弹窗 -->
</template>

<script>
export default {
    data() {
        return {
            //获取当前登录设备
            is_PC: this.$store.state.is_PC,
            ip: this.$store.state.ip,
            //弹窗表单
            form: {
                EnterBabyID: '',
                EnterBabyName: '',
                EnterDateTime: '',
                EnterParentID: '',
                EnterParentName: '',
                EnterParentPhone: '',
                EnterCourse: '莫卡乐概念美术免费试听公开课',
                EnterClass: '',
            },
            rules: {
                EnterBabyID: [{
                    required: true,
                    message: '请选择报名学员',
                    trigger: 'blur'
                }],
                EnterParentName: [{
                    required: true,
                    message: '请填写您的称呼',
                    trigger: 'blur'
                }],
            },
            //新增学生表单内容
            babyForm: {
                UserID: this.$store.state.login_user.UserID,
                BabyID: '',
                UserImg: '',
                NikeName: '',
                RealName: '',
                Sex: 0,
                FromSchool: '',
                SchoolGrade: '',
                Birthday: '',
                onRead: true,
            },

        }
    },
    components: {

    },

    computed: {
        //报名弹窗
        EnterModalVisible() {
            return this.$store.getters.get_courseEnter_visible;
        },
        //登录用户资料
        user() {
            if (this.$store.getters.get_login_user_data) {
                return this.$store.getters.get_login_user_data;
            } else {
                return JSON.parse(localStorage.getItem("user"));
            }
        },
    },
    created() {
        this.getDateTime();
    },
    mounted() {

    },

    methods: {
        //打开新增学生弹窗
        //增
        addStudent() {
            this.$store.commit('update_babyModal_visible', true)
            this.$store.commit('update_babyModal_form', this.babyForm)
        },
        //弹窗选择学生
        selectStudent(item) {
            this.form.EnterBabyID = item.BabyID;
            this.form.EnterBabyName = item.RealName;
            if (this.user) {
                this.form.EnterParentID = this.user.UserID;
                this.form.EnterParentName = this.user.RealName;
                this.form.EnterParentPhone = this.user.CellPhone;
            }
        },
        //点击关闭按钮
        handleClose(done) {
            this.$store.commit('update_courseEnterVisible', false)
        },
        //获取今天日期
        getDateTime() {
            let obj = new Date();
            let year = obj.getFullYear();
            let month = obj.getMonth();
            let day = obj.getDate();
            this.form.EnterDateTime = new Date(year, month, day + 1, 14, 30)
        },
        //线下课程报名
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.postEnterCourse();
                } else {
                    this.$message.error("请选择报名学员");
                    return false;
                }
            });
        },
        postEnterCourse() {
            let that = this;
            let params = this.form;
            this.$store.dispatch('postEnterCourse', params).then((response) => {
                let res = response;
                // console.log(response)
                if (res.statusText === 'Created' || res.status === 201) {
                    console.log(response)
                    this.$alert('您已预约成功，工作人员将会在12小时内与您取得联系，请保持电话畅通', '提示', {
                        confirmButtonText: '确定',
                        // cancelButtonText: '取消',
                        callback: action => {
                            that.$store.commit('update_courseEnterVisible', false)
                        }
                    })
                } else {
                    this.$message.error(res.detail);
                }
            }).catch(err => {
                this.$message.error("您当前网络有问题，请稍后再试。");
            });

        },
    },
}
</script>

<style scoped>
.enterModal>>>.el-dialog {
    width: 900px;
}

.plus-students-box {
    display: flex;
    background: #FFFFFF;
    border: 1px dashed #D3DCE6;
    border-radius: 6px;
    width: 240px;
    padding: 10px;
    align-items: center;
    transition: all .5s;
    margin-right: 10px;
    height: 80px;
}

.plus-students-box:hover {
    border: 1px dashed #57BC4C;
    transition: all .5s;
}

.plus-img-box {
    transition: all .5s;
    border: 1px solid #D3DCE6;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    text-align: center;
    line-height: 64px;
    margin-right: 20px;
}

.plus-text-box {
    margin: 0;
    line-height: 20px;
}

.el-form-item>>>.el-form-item__content {
    display: flex;
    flex-wrap: wrap;
}

.pc-course-detail>>>.el-dialog__body {
    padding-top: 10px;
}

.select-students-box {
    display: flex;
    background: #FFFFFF;
    border: 1px solid #D3DCE6;
    border-radius: 6px;
    width: 240px;
    padding: 10px;
    align-items: center;
    transition: all .5s;
    margin-right: 10px;
    position: relative;
    height: 80px;
    margin-bottom: 10px;
}

.select-students-box .el-image {
    border: 1px solid #D3DCE6;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 20px;
}

.select-students-box img {
    position: absolute;
    top: 0;
    right: 0;
}

.select-students-active {
    border: 1px solid #57BC4C;
}

.el-form-item>>>.el-input {
    width: 240px;
}

.has-promotion {
    background: #FF4949;
    color: #fff;
    padding: 2px 10px;
    display: inline-block;
    border-radius: 12px;
    font-size: 12px;
    text-align: center;
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/courseEnterModal.vue